export const Views = {
    News: "news",
    Home: "home",
    NewTracks: "newTracks",
    Catalog: "catalog",
    Search: "search",
    Favorites: "favorites",
    BackgroundMusic: "backgroundMusic",
    BackgroundMusicPlayer: "backgroundMusicPlayer",
    BackgroundMusicStyles: "backgroundMusicStyles",
    BackgroundMusicSearch: "backgroundMusicSearch",
    BackgroundMusicPlaylists: "backgroundMusicPlaylists",
    Singers: "singers",
    PlayLists: "playlists",
    Settings: "settings",
    Account: "account",
    Player: "player",
    Feedback: "feedback",
    ChangePassword: "changePassword",
    ChangeUsername: "changeUsername",
    Blank: "blank",
    SongbookPerformances: "songbookPerformances",
    SongbookQueue: "songbookQueue"
};